import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import withThemeProps from '../../../theme/withThemeProps';
/**
 * @param {import('../types').FormInputEcrionCheckboxProps} props
 */

var CheckboxFormInput = function CheckboxFormInput(_ref) {
  var label = _ref.label,
      labelPlacement = _ref.labelPlacement,
      checked = _ref.checked,
      disabled = _ref.disabled,
      error = _ref.error,
      rest = _objectWithoutProperties(_ref, ["label", "labelPlacement", "checked", "disabled", "error"]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var className = focused ? "Mui-focused" + (error ? "Mui-error" : "") : "" + (error ? "Mui-error" : "");
  var control = React.createElement(MaterialCheckbox, Object.assign({}, rest, {
    checked: !!checked,
    disabled: !!disabled,
    className: className,
    onFocus: function onFocus() {
      return setFocused(true);
    },
    onBlur: function onBlur() {
      return setFocused(false);
    }
  }));

  if (label) {
    return React.createElement(FormControlLabel, {
      control: control,
      label: label,
      labelPlacement: labelPlacement,
      disabled: !!disabled
    });
  } else {
    return control;
  }
};

CheckboxFormInput.defaultProps = {
  label: '',
  labelPlacement: 'end'
};
export default withThemeProps('Form.Input.Checkbox')(CheckboxFormInput);